import { type LoginCredentials, type UserInfo, type RegisterData, AuthResponse } from "@/types/auth";
import { api } from "@/utils/axiosInterceptor";

export const authApi = {

	forgotPassword: async (email: string) => {
		try {
		  const response = await api.post("/auth/forgot-password", { email });
		  return response.data;
		} catch (error) {
		  if (error instanceof Error) {
			console.error("Forgot Password Error:", (error as any).response?.data || error.message);
		  } else {
			console.error("Forgot Password Error:", error);
		  }
		  throw error;
		}
	  },

	  resetPassword: async (token: string, password: string) => {
	
		try {
			const response = await api.post("/auth/resetpassword", { token, password });
			return response.data;
		} catch (error: any) {
			console.error("Error:", error.response ? error.response.data : error.message);
			throw error;
		}
	},
	
	  
	register: async (data: RegisterData) => {
		const response = await api.post("/auth/register", data);
		return response.data;
	},

	login: async (credentials: LoginCredentials) => {
		const response = await api.post<AuthResponse>("/auth/login", credentials);
		return response.data;
	},

	refreshToken: async () => {
		const response = await api.post<AuthResponse>("/auth/refresh-token");
		return response.data;
	},

	getUser: async () => {
		const response = await api.get<UserInfo>("/auth/whoami");
		return response.data;
	},

	logout: async () => {
		await api.post("/auth/logout");
	},
};